import { ApiChartAttribute } from "@incendium/api";
import { useSelectedProject } from "Hooks/useSelectedProject";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

function useDimensionExplorerNavigation() {
  const history = useHistory();
  const { selectedClient, selectedProject } = useSelectedProject();

  const onDimensionClick = useCallback(
    (dimension: string, attributes?: ApiChartAttribute[]) => {
      if (!selectedClient || !selectedProject) {
        return;
      }

      let search = `d=${encodeURIComponent(dimension)}`;
      if (attributes) {
        search += `&at=${encodeURIComponent(JSON.stringify(attributes))}`;
      }
      history.push({
        pathname: `/clients/${selectedClient.id}/projects/${selectedProject.id}/analyse/standard-reports/dimension-explorer`,
        search,
      });
    },
    [history, selectedClient, selectedProject],
  );

  return onDimensionClick;
}

export default useDimensionExplorerNavigation;
